<div class="title_description">
   <div class="title_with_name_row">
      <div class="icon_name" *ngIf="!hideLogo">
         <img
            *ngIf="stockLogo; else fallback"
            [src]="stockLogo"
            [alt]="stockName"
         />
         <ng-template #fallback>
            <div class="stock-initial">{{ stockName?.charAt(0) }}</div>
         </ng-template>
      </div>
      <h1 class="company-chart-name mb-0 fw-600">
         {{ stockName }}.
         {{
            type === "etf"
               ? stockName?.includes("ETF")
                  ? "Analysis"
                  : "ETF Analysis"
               : "Stock Analysis"
         }}
         <span>{{ stockTicker }}</span>
      </h1>
   </div>

   <div class="ticker-chips-container d-flex align-items-center gap-2 mt-2">
      <!-- <h4 class="mb-0 fw-500">{{ stockTicker }}</h4> -->
      <!-- Chips Container (Beside Ticker) -->
      <ng-container *ngIf="type === 'etf'; else stockChips">
         <div class="chips-container d-flex align-items-center flex-wrap gap-2">
            <span
               class="stock-chip cursor-pointer d-flex align-items-center ps-2 gap-2 text-nowrap rounded-pill"
               *ngIf="stock?.etfProfileInfo?.domicile"
               [routerLink]="'/etf-screener'"
               [queryParams]="{
                  page: 1,
                  country: stock?.etfProfileInfo?.domicile?.toUpperCase()
               }"
            >
               <img
                  [src]="
                     '/assets/flags/1x1/' +
                     stock?.etfProfileInfo?.domicile?.toLowerCase() +
                     '.svg'
                  "
                  width="16"
                  height="16"
                  class="img-fluid rounded-circle"
               />
               <span>{{ stock?.etfProfileInfo?.domicile }}</span>
            </span>
            <span
               class="stock-chip cursor-pointer text-nowrap rounded-pill"
               *ngIf="stock?.etfProfileInfo?.assetClass"
               [routerLink]="'/etf-screener'"
               [queryParams]="{
                  page: 1,
                  'filters[assetClass]': stock?.etfProfileInfo?.assetClass,
                  country: stock?.etfProfileInfo?.domicile?.toUpperCase()
               }"
            >
               {{ stock?.etfProfileInfo?.assetClass }}
            </span>

            <!-- [routerLink]="'/etf-screener'"
           [queryParams]="{
             page: 1,
             investmentSegment: stock?.etfProfileInfo?.investmentSegment,
             country: stock?.etfProfileInfo?.domicile?.toUpperCase()
           }" -->
            <span
               class="stock-chip text-nowrap rounded-pill"
               *ngIf="stock?.etfProfileInfo?.investmentSegment"
            >
               {{
                  stock?.etfProfileInfo?.investmentSegment
                     | categoryToText
                     | titlecase
               }}
            </span>
         </div>
      </ng-container>

      <ng-template #stockChips>
         <div class="chips-container d-flex align-items-center flex-wrap gap-2">
            <span
               class="stock-chip cursor-pointer d-flex align-items-center ps-2 gap-2 text-nowrap rounded-pill"
               *ngIf="fullCountryName"
               [routerLink]="'/stock-screener'"
               [queryParams]="{
                  country: stock?.companyProfile?.country,
                  page: 1
               }"
            >
               <img
                  [src]="
                     '/assets/flags/1x1/' +
                     stock?.companyProfile?.country?.toLowerCase() +
                     '.svg'
                  "
                  width="16"
                  height="16"
                  class="img-fluid rounded-circle"
               />
               <span>{{ fullCountryName }}</span>
            </span>
            <span
               class="stock-chip cursor-pointer text-nowrap rounded-pill"
               *ngIf="stock?.companyProfile?.musaffaSectorName"
               [routerLink]="'/stock-screener'"
               [queryParams]="{
                  country: stock?.companyProfile?.country,
                  page: 1,
                  'filters[sector]': stock?.companyProfile?.musaffaSectorName
               }"
            >
               {{ stock?.companyProfile?.musaffaSectorName }}
            </span>
            <span
               class="stock-chip cursor-pointer text-nowrap rounded-pill"
               *ngIf="stock?.companyProfile?.marketCapClassification"
               [routerLink]="'/stock-screener'"
               [queryParams]="{
                  country: stock?.companyProfile?.country,
                  page: 1,
                  'filters[marketCapClassification]':
                     stock?.companyProfile?.marketCapClassification
               }"
            >
               {{
                  stock?.companyProfile?.marketCapClassification
                     | categoryToText
                     | titlecase
               }}
            </span>
            <span
               class="stock-chip cursor-pointer text-nowrap rounded-pill"
               *ngIf="quarterText && lastUpdatedMeta"
            >
               Report:
               <time [attr.datetime]="lastUpdatedMeta">
                  {{ quarterText }}
               </time>
            </span>
         </div>
      </ng-template>
   </div>

   <div [ngClass]="{ expanded: isExpanded }" class="text-container">
      {{ stockDescription }}
   </div>
   <a
      class="read_more"
      href="javascript:void(0);"
      (click)="isExpanded = !isExpanded"
   >
      {{ isExpanded ? "Read Less" : "Read More" }}
   </a>
</div>
